import { AddressService } from '@spa/services/address'
import { convertToRegionId } from '@spa/services/region'

export interface AddressFormState {
  zipcode: string,
  prefectureCode: string,
  city: string,
  town: string,
}

type SearchedAddressFormState = Omit<AddressFormState, 'zipcode'>

export class AddressSearchInteraction {
  public async search(zipcode: string): Promise<SearchedAddressFormState> {
    const addressSearchResult  = await AddressService.get(zipcode)

    return {
      prefectureCode: convertToRegionId(addressSearchResult.prefecture) || '',
      city: `${addressSearchResult.city}${addressSearchResult.town}`,
      town: '',
    }
  }
}
